/* =====================================================================
 * Common JS
 * =====================================================================
 * 1. Smooth Scroll
 * 2. Trigger Rellax/AOS
 * 3. Scroll Animations
 * 4. Video Controls
 * 5. Input State/City
 * 6. Input Mask
 * 7. Solutions Animated Icons
 * ===================================================================*/

import AOS from 'aos';
import Rellax from 'rellax';
import helpers from './helpers.js';
import VMasker from 'vanilla-masker';
import videoControl from './vendor/video-control.js';
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll';

(function (doc, win, $) {

  /* ---------------------------------------------------------------------
   * 1. Smooth Scroll
   * -------------------------------------------------------------------*/

  const scrollLinks = doc.querySelectorAll('a[href*="#"]');
  Array.prototype.forEach.call(scrollLinks, (toggle) => {
    toggle.addEventListener('click', (event) => {
      const anchor = doc.getElementById(toggle.href.split('#')[1]);
      if (!anchor) return;

      event.preventDefault();

      const scroll = new SmoothScroll();
      const speed = toggle.dataset.scrollSpeed ? toggle.dataset.scrollSpeed : 2500;

      const config = {
        speed: speed,
        updateURL: false,
        speedAsDuration: true,
        easing: 'easeInOutQuint'
      };

      scroll.animateScroll(anchor, toggle, config);
    });
  });

  /* ---------------------------------------------------------------------
   * 2. Trigger Rellax/AOS
   * -------------------------------------------------------------------*/

  new Rellax('.rellax');

  AOS.init({
    duration: 800,
    easing: 'ease-in-out'
  });

  /* ---------------------------------------------------------------------
   * 3. Scroll Animations
   * -------------------------------------------------------------------*/

  const scaleOnScroll = (element, from, to, speed) => {
    if (win.innerWidth < 840) {
      speed = (speed - 200);
    }

    const getScaleValue = () => {
      const scrollTop = Math.round(doc.documentElement.scrollTop);
      return (scrollTop / speed);
    };

    const initialValue = getScaleValue() < from ? from : to;
    element.style.transform = 'scale(' + initialValue + ')';

    win.addEventListener('scroll', () => {
      if (getScaleValue() >= from && getScaleValue() <= to) {
        element.style.transform = 'scale(' + getScaleValue() + ')';
      }
    });
  };

  const root = doc.querySelector('.root');
  if (root) scaleOnScroll(root, 0.15, 0.8, 900);

  const videoAbout = doc.querySelector('.videoAbout');
  if (videoAbout) scaleOnScroll(videoAbout, 0.4, 1, 700);

  /* ---------------------------------------------------------------------
   * 4. Video Controls
   * -------------------------------------------------------------------*/

  const videoCover = doc.querySelector('.videoCover');
  const videoCoverIcon = doc.querySelector('.videoCover-icon');
  if (videoCover) {
    videoCover.addEventListener('click', () => {
      videoControl.callPlayer('videoAbout', 'playVideo');
      videoCover.classList.add('u-hide');
      videoCoverIcon.classList.add('u-hide');
    });
  }

  /* ---------------------------------------------------------------------
   * 5. Input State/City
   * -------------------------------------------------------------------*/

  const apiRequest = (endpoint, callback) => {
    const apiURL = 'https://br-cidade-estado-nodejs.glitch.me/';
    const request = new XMLHttpRequest();
    request.open('GET', apiURL + endpoint, true);
    request.onload = () => {
      const status = request.status;
      if (status >= 200 && status < 400) {
        const response = JSON.parse(request.responseText);
        callback(response);
      }
    };
    request.send();
  };

  const populateCities = (state, select) => {
    apiRequest('estados/' + state + '/cidades', (cities) => {
      cities.forEach((city) => {
        const option = doc.createElement('option');
        option.text = city.cidade;
        option.value = city.cidade;
        select.appendChild(option);
      });
      select.disabled = select.options.length > 1 ? false : true;
    });
  };

  const selectCityGF = doc.querySelectorAll('.js-selectCity select');
  Array.prototype.forEach.call(selectCityGF, (select) => select.disabled = true);

  const selectStateGF = doc.querySelectorAll('.js-selectState select');
  Array.prototype.forEach.call(selectStateGF, (select) => {
    select.addEventListener('change', () => {
      const state = select.value;
      const form = helpers.getParentByNodeName(select, 'FORM');
      const selectCity = form.querySelector('.js-selectCity select');
      selectCity.innerHTML = '<option value="">Selecione...</option>';
      if (!state) return;
      populateCities(state, selectCity);
    });
  });

  $(document).on('gform_confirmation_loaded', (event, formId) => {
    if (formId === 2) {
      helpers.triggerEvent(doc, 'simulator_form_sent');
    }
  });

  /* ---------------------------------------------------------------------
   * 6. Input Mask
   * -------------------------------------------------------------------*/

  const inputHandler = (masks, max, target) => {
    const value = target.value;
    const mask = value.length > max ? 1 : 0;
    VMasker(target).unMask();
    VMasker(target).maskPattern(masks[mask]);
    target.value = VMasker.toPattern(value.replace(/\D/g, ''), masks[mask]);
  };

  ['click', 'focusin', 'input', 'keyup'].forEach((eventType) => {
    doc.addEventListener(eventType, (event) => {
      const target = event.target;
      const parent = target.parentNode.parentNode;

      if (!parent.classList || !parent.classList.contains('mask-phone')) return;

      const telMask = ['(99) 9999-99999', '(99) 99999-9999'];
      VMasker(target).maskPattern(telMask[0]);
      inputHandler(telMask, 14, target);
    });
  });

  /* ---------------------------------------------------------------------
   * 7. Solutions Animated Icons
   * -------------------------------------------------------------------*/

  var scrollPos = 0;
  const solutionVideos = doc.querySelectorAll('.sectionSolutions video');
  win.addEventListener('scroll', () => {
    Array.prototype.forEach.call(solutionVideos, (video) => {
      if (helpers.isInViewport(video)) {
        if (video.currentTime > 0) return;
        video.play();
        return;
      }

      if ((doc.body.getBoundingClientRect()).top > scrollPos) {
        if (!doc.querySelector('.sectionSolutions .aos-animate')) {
          video.currentTime = 0;
          video.pause();
        }
      }
    });

    scrollPos = (doc.body.getBoundingClientRect()).top;
  });

}(document, window, jQuery));
